import * as React from 'react';
import { Location } from 'history';
import { parse } from 'qs';
import { cleanSearchQuery } from '../../../../api';
import { connect } from 'react-redux';
import { RequestApiResult, RequestApiHttpPayload, requestAPIActions } from 'loopback-react-request';
import { Redirect } from 'react-router';
import { ActivationSucceeded } from 'src/app/Partials/Authentification/Activation/ActivationSucceeded';
import { ActivationFailed } from 'src/app/Partials';

export interface VerificationParameter {
  uid: string;
  token: string;
}

export interface ActivateAccountProps {
  confirmAccount:  RequestApiResult<any>;
  dispatch: any;
  location: Location;
}

export interface ActivateAccountState {
}

export class ActivateAccountComponent extends React.Component<ActivateAccountProps, ActivateAccountState> {
  componentDidMount() {
    this.confirmAccount();
  }

  public render() {
    const { confirmAccount } = this.props;
    const verificationParameter = this.verificationParameter;
    const uid = verificationParameter && verificationParameter.uid;
    const token = verificationParameter && verificationParameter.token;
    return (
      <div className="page-activate-account d-flex justify-content-center align-items-center h-100">
        <div className="inner w-100 pt-5 pb-5">
          {confirmAccount && !confirmAccount.result && confirmAccount.error && (
              <ActivationFailed error={confirmAccount.error}/>
          )}
        
        {!verificationParameter || !uid || !token && (
          <Redirect to="/" />
        )}
        {confirmAccount && !confirmAccount.updating && confirmAccount.loaded && (
          <>
            {confirmAccount && (confirmAccount.meta && confirmAccount.meta.status === 204) && !confirmAccount.error && (
              <ActivationSucceeded />
            )}
            {confirmAccount && (confirmAccount.meta && confirmAccount.meta.status !== 204) && confirmAccount.error && (
              <ActivationFailed error={confirmAccount.error}/>
            )}
          </>
        )}
        {confirmAccount && !confirmAccount.updating && !confirmAccount.loaded && (
          <>
            {confirmAccount && (confirmAccount.meta && confirmAccount.meta.status !== 204) && confirmAccount.error && (
              <ActivationFailed error={confirmAccount.error}/>
            )}
          </>
        )}
        </div>
      </div>
    );
  }
  
  private confirmAccount() {
    if (!this.verificationParameter ) { return; }
    const { confirmAccount } = this.props;
    const { uid, token} = this.verificationParameter;
    
    if (uid && token) {
      if (confirmAccount && !confirmAccount.loaded && !confirmAccount.updating) {
        this.props.dispatch(requestAPIActions.load<RequestApiHttpPayload>('confirmAccount', {
          url: `/Users/confirm?uid=${uid}&token=${token}`,
          queryType: false,
        }));
      }
    }
  }

  private get verificationParameter(): VerificationParameter | undefined {
    const { location } = this.props;
    if (!location || (location && !location.search)) { return; }
    return parse(cleanSearchQuery(location.search));
  }
}

interface StateProps {
  confirmAccount: RequestApiResult<any>;
}

export const ActivateAccountPage = connect((state: StateProps) => ({
  confirmAccount:  state.confirmAccount,
}))(ActivateAccountComponent);

export default ActivateAccountPage;